import { videoCallGenerate } from "@/api/coachcontact";
import store from "@/store";

function getDataString(data = {}) {
    let dataString = "";

    for (let key in data) {
        dataString += "&" + key + "=" + String(data[key]).trim();

        if (
            data[key] &&
            typeof data[key] === "object" &&
            data[key].constructor === Array
        ) {
            for (let arraykey in data[key]) {
                dataString += "&" + key + "[]=" + data[key][arraykey];
            }
        }
    }
    dataString = dataString.substr(1);
    return dataString;
}

function isPageLoggedOutAllowed(pageName) {
    if (
        pageName === "login" ||
        pageName === "page-not-found" ||
        pageName === "aktivierung" ||
        pageName === "dashboard - nicht eingeloggt" ||
        pageName === "immowert" ||
        pageName === "video-meeting" ||
        pageName === "video-termin-abschluss" ||
        pageName === "services-schmerzlinderung" ||
        pageName === "my21" ||
        pageName === "my21-day" ||
        pageName === "me1ns" ||
        pageName === "me1nzuhause" ||
        pageName === "me1nzuhause-vortrag" ||
        pageName === "video-termin" ||
        pageName === "video-termin-abschluss" ||
        pageName === "video-meeting" ||
        pageName === "protected" ||
        pageName.includes("schadensmeldung")
    ) {
        return true;
    } else {
        return false;
    }
}

function checkPageAccess(page, password) {
    return new Promise((resolve, reject) => {
        const pageUrl = "https://www.klickmal.at" + page;
        if (pageUrl && pageUrl.includes("/services/video-termin-abschluss")) {
            const url = new URL(pageUrl);
            const id = url.searchParams.get("id");
            store.commit("setLoading", true);
            videoCallGenerate({
                password: password,
                beraterid: id,
                checkpassword: true,
            })
                .then((response) => {
                    if (
                        response.data.Status === 400 &&
                        response.data.Errors &&
                        response.data.Errors.password
                    ) {
                        resolve(false);
                    } else {
                        resolve(true);
                    }
                })
                .catch(() => {
                    reject();
                });
        }
    });
}

export { getDataString, isPageLoggedOutAllowed, checkPageAccess };
